import React, { useEffect, useState } from 'react';
import Badge from '@mui/material/Badge';

type DraggableBadgeType = { isDragging: boolean, selectedRowCount: number };

const DraggableBadge = (props: DraggableBadgeType) => {
  const { isDragging, selectedRowCount } = props;
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [, setInitialMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      setMousePosition({ x: event.clientX, y: event.clientY });
    };

    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
    } else {
      window.removeEventListener('mousemove', handleMouseMove);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isDragging]);

  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      setInitialMousePosition({ x: event.clientX, y: event.clientY });
      setMousePosition({ x: event.clientX, y: event.clientY });
    };

    if (isDragging) {
      window.addEventListener('mousedown', handleMouseDown);
    } else {
      window.removeEventListener('mousedown', handleMouseDown);
    }

    return () => {
      window.removeEventListener('mousedown', handleMouseDown);
    };
  }, [isDragging]);

  if (!isDragging || selectedRowCount <= 1) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: mousePosition.y - 11,
        left: mousePosition.x - 22,
        pointerEvents: 'none',
        zIndex: 9999,
      }}
    >
      <Badge badgeContent={selectedRowCount} color='primary'></Badge>
    </div>
  );
};

export default DraggableBadge;
